import { z } from 'zod';
import { PASSWORD_MAX_LENGTH, PASSWORD_MIN_LENGTH, UID_REGEX } from '../constants.js';
/**
 * Password policy. Deliberately length-first: a 12-character passphrase beats
 * a 8-character symbol soup, and the generated credentials we hand out are
 * high-entropy anyway.
 */
export const passwordSchema = z
    .string()
    .min(PASSWORD_MIN_LENGTH, `Password must be at least ${PASSWORD_MIN_LENGTH} characters`)
    .max(PASSWORD_MAX_LENGTH)
    .refine((v) => /[a-z]/.test(v), 'Must contain a lowercase letter')
    .refine((v) => /[A-Z]/.test(v), 'Must contain an uppercase letter')
    .refine((v) => /[0-9]/.test(v), 'Must contain a digit');
export const loginSchema = z.object({
    /**
     * The email address is the login ID. The legacy NLK-XXXX-XXXX uid is still
     * accepted so older credentials keep working.
     */
    identifier: z
        .string()
        .trim()
        .min(3)
        .max(255)
        .transform((v) => (UID_REGEX.test(v.toUpperCase()) ? v.toUpperCase() : v.toLowerCase())),
    password: z.string().min(1).max(PASSWORD_MAX_LENGTH),
});
export const verifyOtpSchema = z.object({
    challengeId: z.string().uuid(),
    code: z
        .string()
        .trim()
        .regex(/^\d{4,10}$/, 'Code must be numeric'),
});
export const resendOtpSchema = z.object({ challengeId: z.string().uuid() });
export const changePasswordSchema = z
    .object({
    currentPassword: z.string().min(1),
    newPassword: passwordSchema,
    confirmPassword: z.string(),
})
    .refine((v) => v.newPassword === v.confirmPassword, {
    message: 'Passwords do not match',
    path: ['confirmPassword'],
})
    .refine((v) => v.newPassword !== v.currentPassword, {
    message: 'New password must differ from the current one',
    path: ['newPassword'],
});
export const updateProfileSchema = z.object({
    fullName: z.string().trim().min(2).max(120).optional(),
    phone: z.string().trim().max(32).nullish(),
    company: z.string().trim().max(120).nullish(),
});
//# sourceMappingURL=auth.js.map